import { Injectable } from "@angular/core";
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router,
    UrlTree,
} from "@angular/router";
import { Observable, map } from "rxjs";

import { RESET_PWD_ANGULAR, FeatureFlagFacade } from "@hermes/states/flipper";

@Injectable()
export class ResetPasswordGuard implements CanActivate {
    constructor(
        private featureFlagFacade: FeatureFlagFacade,
        private router: Router,
    ) {}

    public canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Observable<boolean | UrlTree> {
        return this.featureFlagFacade.isActivated(RESET_PWD_ANGULAR).pipe(
            map((isEnabled) =>
                isEnabled && !!route.queryParamMap.get("hash")
                    ? true
                    : this.router.createUrlTree(["/404-error"], {
                          queryParams: { originalUrl: state.url },
                      }),
            ),
        );
    }
}
